import { Injectable, NgModule } from '@angular/core';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { RequestService } from '../request/request.service';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import moment from 'moment';
import { HTTP } from '@ionic-native/http/ngx';
import {HttpClient, HttpEvent, HttpEventType, HttpRequest} from '@angular/common/http';
//import * as xmlparse2 from 'xml2js';
import {LocalNotifications} from '@ionic-native/local-notifications/ngx';
import {Platform} from '@ionic/angular';
import {Observable} from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { NativeLiveActivities } from 'src/app/plugins/native-runtime.plugins';
import {CameraServiceService} from "../multimedia/camera-service.service";
import {Capacitor} from "@capacitor/core";
import {FilePath} from '@ionic-native/file-path/ngx';
import {FileChooser} from '@ionic-native/file-chooser/ngx';
//import {Base64} from '@ionic-native/base64/ngx';
import Swal2 from 'sweetalert2';
import { isVideo,isImage, video_extensions, image_extensions } from 'src/app/utils';
import * as uuid from 'uuid';
import { HttpHeaders } from '@angular/common/http';
import { Key } from 'protractor';
import { File } from '@ionic-native/file/ngx';
export interface UploadResponse {
  link: string;
  mimeType: string;
  /** Public JPEG preview generated from the midpoint of an uploaded video. */
  posterLink?: string;
}

export interface ExistingPublicationMedia {
  source: 'remote_url';
  remoteUrl: string;
  mimeType: string;
  filename: string;
}

export interface UploadUiState {
  active: boolean;
  percent: number;
  loaded: number;
  total: number;
  phase: 'idle' | 'preparing' | 'uploading' | 'finishing' | 'complete' | 'error';
  title: string;
  message: string;
}

export interface ThirdPartyPlatformPublishProgress {
  platform: string;
  progress: number;
  state: 'queued' | 'processing' | 'success' | 'error';
  message: string;
}

export interface ThirdPartyPublishUiState {
  active: boolean;
  state: 'processing' | 'success' | 'error';
  title: string;
  message: string;
  globalPercent: number;
  platforms: ThirdPartyPlatformPublishProgress[];
}
@Injectable({
  providedIn: 'root'
})


export class UploadMultimediaService {
  image = '';
  multimediaImage:Array<object>=[]
  blob: any;
  filename = '';
  type = '';
  video: string | null = null;
  Blob2
  blobAR:Array<object>=[]
  private readonly defaultUploadUiState: UploadUiState = {
    active: false,
    percent: 0,
    loaded: 0,
    total: 0,
    phase: 'idle',
    title: 'Laniakea Superintelligence',
    message: 'Preparing media transcendence.',
  };
  private uploadUiStateSubject = new BehaviorSubject<UploadUiState>(this.defaultUploadUiState);
  public uploadUiState$ = this.uploadUiStateSubject.asObservable();
  private uploadUiResetTimeout?: ReturnType<typeof setTimeout>;
  private uploadActivityOperation: Promise<void> = Promise.resolve();
  private uploadActivityLastSentAt = 0;
  private uploadActivityLastSentProgress = -1;
  private uploadActivityLastSentPhase: UploadUiState['phase'] = 'idle';
  private thirdPartyPublishResetTimeout: ReturnType<typeof setTimeout> | null = null;
  private thirdPartyPublishUiStateSubject = new BehaviorSubject<ThirdPartyPublishUiState>({
    active: false,
    state: 'processing',
    title: 'Alien Intelligence · Social transmission',
    message: '',
    globalPercent: 0,
    platforms: [],
  });
  public thirdPartyPublishUiState$ = this.thirdPartyPublishUiStateSubject.asObservable();

  constructor(
    private transfer: FileTransfer,
    private androidPermissions: AndroidPermissions,
    private request: RequestService,
    private fileOpener: FileOpener,
    private http: HTTP,
    private httpc: HttpClient,
    private localNotification: LocalNotifications,
    private platform: Platform,
    private cameraService: CameraServiceService,
    public filePath: FilePath,
    public fileChooser: FileChooser,
    private file: File
    //public base64: Base64,
  ) {}

  private readonly publicationMediaMimeTypes: { [extension: string]: string } = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
    gif: 'image/gif',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    m4v: 'video/x-m4v',
    webm: 'video/webm',
  };

  /**
   * Validates an already-uploaded public media URL and derives its media type.
   * Keeping this normalization in the upload service ensures every publication
   * branch applies the same allowlist and can later support multiple URLs.
   */
  public prepareExistingPublicationMedia(rawUrl: string): ExistingPublicationMedia {
    const normalizedUrl = String(rawUrl || '').trim();
    let parsedUrl: URL;

    try {
      parsedUrl = new URL(normalizedUrl);
    } catch {
      throw new Error('La URL de multimedia no es válida.');
    }

    if (parsedUrl.protocol !== 'https:') {
      throw new Error('La multimedia debe usar una URL HTTPS pública.');
    }

    const hostname = parsedUrl.hostname.toLowerCase();
    const isWixMedia = hostname === 'wixstatic.com' || hostname.endsWith('.wixstatic.com');
    const isLaniakeaS3 =
      hostname === 'laniakea-multimedia.s3.amazonaws.com' ||
      (hostname.startsWith('laniakea-multimedia.s3.') && hostname.endsWith('.amazonaws.com')) ||
      (hostname === 's3.amazonaws.com' && parsedUrl.pathname.startsWith('/laniakea-multimedia/'));
    const isLaniakeaMedia =
      hostname === 'laniakea.com' ||
      hostname.endsWith('.laniakea.com');

    if (!isWixMedia && !isLaniakeaS3 && !isLaniakeaMedia) {
      throw new Error('Solo se aceptan URLs públicas de multimedia de Laniakea o Wix.');
    }

    const decodedPath = decodeURIComponent(parsedUrl.pathname);
    const filename = decodedPath.substring(decodedPath.lastIndexOf('/') + 1);
    const extensionMatch = filename.toLowerCase().match(/\.([a-z0-9]+)$/);
    const extension = extensionMatch?.[1] || '';
    const mimeType = this.publicationMediaMimeTypes[extension];

    if (!mimeType) {
      throw new Error('No se pudo identificar una extensión de imagen o video compatible en la URL.');
    }

    return {
      source: 'remote_url',
      remoteUrl: parsedUrl.toString(),
      mimeType,
      filename,
    };
  }

  private resolveExistingPublicationMedia(blobfile: any): ExistingPublicationMedia | null {
    if (blobfile?.source === 'remote_url' && blobfile?.remoteUrl) {
      return this.prepareExistingPublicationMedia(blobfile.remoteUrl);
    }

    return null;
  }

  ngOnInit() {
    this.image = null;
    this.blob = null;
    this.type = '';
    this.filename = '';

  }

  private setUploadUiState(patch: Partial<UploadUiState>) {
    if (this.uploadUiResetTimeout) {
      clearTimeout(this.uploadUiResetTimeout);
      this.uploadUiResetTimeout = undefined;
    }
    this.uploadUiStateSubject.next({
      ...this.uploadUiStateSubject.value,
      ...patch,
    });
    this.syncUploadLiveActivity(this.uploadUiStateSubject.value);
  }

  private resetUploadUiState(delayMs: number = 0) {
    if (this.uploadUiResetTimeout) clearTimeout(this.uploadUiResetTimeout);
    this.uploadUiResetTimeout = setTimeout(() => {
      this.uploadUiStateSubject.next({ ...this.defaultUploadUiState });
      this.uploadUiResetTimeout = undefined;
      this.endUploadLiveActivity();
    }, delayMs);
  }

  private syncUploadLiveActivity(state: UploadUiState): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    if (!state.active || state.phase === 'idle') {
      this.endUploadLiveActivity();
      return;
    }

    const progress = Math.min(100, Math.max(0, Math.round(Number(state.percent) || 0)));
    const now = Date.now();
    const phaseChanged = state.phase !== this.uploadActivityLastSentPhase;
    if (!phaseChanged && Math.abs(progress - this.uploadActivityLastSentProgress) < 5
      && now - this.uploadActivityLastSentAt < 3000) return;

    this.uploadActivityLastSentAt = now;
    this.uploadActivityLastSentProgress = progress;
    this.uploadActivityLastSentPhase = state.phase;

    const copy: Record<UploadUiState['phase'], { status: string; detail: string }> = {
      idle: { status: 'Ready', detail: 'No upload is active.' },
      preparing: { status: 'Preparing', detail: 'Preparing your media for upload.' },
      uploading: { status: `Uploading ${progress}%`, detail: 'Your media is uploading to Laniakea.' },
      finishing: { status: 'Finalizing', detail: 'Securing your uploaded media.' },
      complete: { status: 'Uploaded', detail: 'Your media upload is complete.' },
      error: { status: 'Interrupted', detail: 'The upload stopped. Return to Laniakea to retry.' },
    };
    const activityCopy = copy[state.phase];

    this.uploadActivityOperation = this.uploadActivityOperation
      .catch(() => undefined)
      .then(async () => {
        if (!this.uploadUiStateSubject.value.active) return;
        const { available } = await NativeLiveActivities.isAvailable();
        if (!available || !this.uploadUiStateSubject.value.active) return;
        await NativeLiveActivities.upsert({
          id: 'laniakea-media-upload',
          kind: 'upload',
          title: 'Media Upload',
          status: activityCopy.status,
          detail: activityCopy.detail,
          progress: progress / 100,
          destination: 'https://laniakea.tv/home',
        });
      })
      .catch(error => console.warn('Media upload Live Activity could not update.', error));
  }

  private endUploadLiveActivity(): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    this.uploadActivityLastSentAt = 0;
    this.uploadActivityLastSentProgress = -1;
    this.uploadActivityLastSentPhase = 'idle';
    this.uploadActivityOperation = this.uploadActivityOperation
      .catch(() => undefined)
      .then(async () => {
        if (this.uploadUiStateSubject.value.active) return;
        await NativeLiveActivities.end({ id: 'laniakea-media-upload' });
      })
      .catch(error => console.warn('Media upload Live Activity could not end.', error));
  }

  public showThirdPartyPublishStatus(
    state: ThirdPartyPublishUiState['state'],
    message: string,
    clearAfterMs = 0,
  ): void {
    if (this.thirdPartyPublishResetTimeout) {
      clearTimeout(this.thirdPartyPublishResetTimeout);
      this.thirdPartyPublishResetTimeout = null;
    }

    const current = this.thirdPartyPublishUiStateSubject.value;
    const platform = this.getThirdPartyPlatformFromMessage(message);
    let platforms = current.platforms;
    if (platform) {
      const stageProgress = this.getThirdPartyStageProgress(state, message);
      const existingIndex = platforms.findIndex(item => item.platform === platform);
      const previous = existingIndex >= 0 ? platforms[existingIndex] : null;
      const updated: ThirdPartyPlatformPublishProgress = {
        platform,
        progress: Math.max(previous?.progress || 0, stageProgress),
        state,
        message,
      };
      platforms = [...platforms];
      if (existingIndex >= 0) platforms[existingIndex] = updated;
      else platforms.push(updated);
    }

    const globalPercent = platforms.length
      ? Math.round(platforms.reduce((sum, item) => sum + item.progress, 0) / platforms.length)
      : current.globalPercent;
    const allComplete = platforms.length > 0
      && platforms.every(item => item.state === 'success' || item.state === 'error');

    this.thirdPartyPublishUiStateSubject.next({
      active: true,
      state: allComplete
        ? (platforms.some(item => item.state === 'error') ? 'error' : 'success')
        : 'processing',
      title: 'Alien Intelligence · Social transmission',
      message,
      globalPercent,
      platforms,
    });

    if (allComplete && clearAfterMs > 0) {
      this.thirdPartyPublishResetTimeout = setTimeout(() => {
        this.dismissThirdPartyPublishStatus();
      }, clearAfterMs);
    }
  }

  public beginThirdPartyPublish(platformNames: string[]): void {
    if (this.thirdPartyPublishResetTimeout) {
      clearTimeout(this.thirdPartyPublishResetTimeout);
      this.thirdPartyPublishResetTimeout = null;
    }
    const platforms = [...new Set(platformNames)].map(platform => ({
      platform,
      progress: 0,
      state: 'queued' as const,
      message: 'Waiting to start…',
    }));
    this.thirdPartyPublishUiStateSubject.next({
      active: platforms.length > 0,
      state: 'processing',
      title: 'Alien Intelligence · Social transmission',
      message: platforms.length ? 'Preparing your selected platforms…' : '',
      globalPercent: 0,
      platforms,
    });
  }

  private getThirdPartyPlatformFromMessage(message: string): string | null {
    const normalized = message.toLowerCase();
    if (normalized.includes('instagram')) return 'Instagram';
    if (normalized.includes('tiktok')) return 'TikTok';
    if (normalized.includes('linkedin')) return 'LinkedIn';
    if (normalized.includes('facebook')) return 'Facebook';
    if (normalized.includes('threads')) return 'Threads';
    if (normalized.includes('youtube')) return 'YouTube';
    if (normalized.includes('browser') || normalized.includes('wix')) return 'Browsers';
    if (message.includes('𝕏') || /\bX\b/i.test(message)) return 'X';
    return null;
  }

  private getThirdPartyStageProgress(
    state: ThirdPartyPublishUiState['state'],
    message: string,
  ): number {
    if (state === 'success' || state === 'error') return 100;
    const normalized = message.toLowerCase();
    if (normalized.includes('finaliz') || normalized.includes('still processing')
      || normalized.includes('checking again') || normalized.includes('preparing it')) return 75;
    if (normalized.includes('prepar') || normalized.includes('normaliz')
      || normalized.includes('compatibility') || normalized.includes('received')) return 30;
    return 55;
  }

  public dismissThirdPartyPublishStatus(): void {
    if (this.thirdPartyPublishResetTimeout) {
      clearTimeout(this.thirdPartyPublishResetTimeout);
      this.thirdPartyPublishResetTimeout = null;
    }
    this.thirdPartyPublishUiStateSubject.next({
      ...this.thirdPartyPublishUiStateSubject.value,
      active: false,
      message: '',
    });
  }
  askForPermission() {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE)
      .then((result) => {
        if (result.hasPermission) {
          console.log('Permissions already done');
        } else {
          this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE)
            .then((result2) => {
              if (result2.hasPermission) {
                console.log('Permissions already done by request');
              } else {
                console.log('Permissions denied');
              }
            });
        }
      });
  }

  public getS3Form(mimeType: string, filename: string) {
    return new Promise((resolve, reject) => {
      const params = {
        mimeType: mimeType,
        filename: filename,
      };
  
      this.request.createRequestPost('s3_form', params)
            .then((result) => {
              if (Capacitor.getPlatform() !== 'web') {
                result = JSON.parse(result);
              }else{
                if (typeof result === 'string') {
                  result = JSON.parse(result);
                     console.log('json result publication service.ts', result);
                   
                   }else {
                    result = result; 
                   }
              }
                
                // Log the received pre-signed URL
                console.log('Received pre-signed URL:', result.s3_form.url);
                
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
    });
}
  

  //public uploadFile(file, filename?) {
    //return new Promise((resolve, reject) => {
      //primera notificacion para indicar el usuario que no cierre
      //if (this.platform.is('android') || this.platform.is('ios')) {
        //this.localNotification.schedule({
          //title: 'Operación: subiendo multimedia al servidor',
          //text: 'Do not close the app until this notification disappears',
          //foreground: true,
        //});
     // }
      //this.cameraService.presentToastWithOptions('Subiendo multimedia al servidor',
        //'No cierres la app hasta que esta una nueva notificación aparezca');
     // const idNotification = 0;
     // this.getS3Form().then((result) => {
       // const params = result;
        //const fields = params['s3_form'];
        //const formdata = new FormData();
        //const url = 'https://s3-us-east-1.amazonaws.com/laniakea-multimedia/';
       // if(filename != null){
         // this.filename = filename;
        //}
        //this.uploadToS3(file, this.filename,formdata,url, fields)
          //.then((stringMedia)=>{
            //if (this.platform.is('android') || this.platform.is('ios')) {
              //this.localNotification.cancelAll();
            //}
           // this.cameraService.presentToastWithOptions();
         //   this.image = '';
        //    resolve(stringMedia);
      //    }).catch((errorS3Upload) => {
    //        reject(errorS3Upload);
     //     });
    //  });
  //  });
 // }

 uploadToS3(blobfile: Blob, filename: string, formdata: FormData, url: string, fields: any): Promise<UploadResponse> {
  console.log("s3 functione", blobfile)
  return new Promise((resolve, reject) => {
    if (!blobfile || !blobfile.type) {
      console.error('File object is undefined or has no type property');
      reject('File object is undefined or has no type property');
      return;
    }
    
    const idNotification = 0;
    const fileExtension = blobfile.type.split('/').pop();
    const filenameWithoutExtension = filename.replace(/\.[^/.]+$/, '');
    const key = 'public/' + moment().format('YYMMDDHHmmss') + '_' + filenameWithoutExtension + '.' + fileExtension;
    const encodedKey = encodeURIComponent(key);
    const uploadUrl = url.replace('{filename}', encodedKey);

    console.log('Upload URL:', uploadUrl);

    const headers = new HttpHeaders().set('Content-Type', blobfile.type);

    const req = new HttpRequest('PUT', uploadUrl, blobfile, {
      reportProgress: true,
      headers: headers,
    });

    this.httpc.request(req).subscribe(
      (event: HttpEvent<any>) => {
        console.log('HTTP event:', event);

        if (event.type === HttpEventType.UploadProgress) {
          const total = event.total || event.loaded || 1;
          const percent = Math.min(100, Math.max(1, Math.round((event.loaded * 100) / total)));
          this.setUploadUiState({
            active: true,
            phase: percent >= 100 ? 'finishing' : 'uploading',
            percent,
            loaded: event.loaded,
            total,
            title: 'Alien Superintelligence Upload',
            message: percent >= 100
              ? 'Finalizing your media. Stay in the app while the signal is secured.'
              : 'Please stay in the app while your media is being uploaded into the intelligence field.',
          });
          if (this.platform.is('android') || this.platform.is('ios')) {
            this.localNotification.update({
              id: idNotification,
              progressBar: { value: percent },
            });
          }
          if (event.loaded == event.total) {
            if (this.platform.is('android') || this.platform.is('ios')) {
              this.localNotification.update({
                id: idNotification,
                progressBar: { value: 100 },
              });
            }
          }
        } else if (event.type === HttpEventType.Response) {
          const uploadedUrl = `${uploadUrl.split('?')[0]}`;
          console.log('Uploaded URL:', uploadedUrl);
          this.setUploadUiState({
            active: true,
            phase: 'complete',
            percent: 100,
            loaded: blobfile.size || this.uploadUiStateSubject.value.loaded,
            total: blobfile.size || this.uploadUiStateSubject.value.total,
            title: 'Upload Complete',
            message: 'Multimedia transcendence completed successfully. Continue your journey.',
          });
          this.resetUploadUiState(1600);
          resolve({
            link: uploadedUrl,
            mimeType: blobfile.type,
          });
        }
      },
      (error) => {
        console.error('HTTP request error:', error);
        this.setUploadUiState({
          active: true,
          phase: 'error',
          title: 'Upload Interrupted',
          message: 'The media signal was interrupted. Please try again without closing the app.',
        });
        this.resetUploadUiState(1800);
        reject('Error al subir multimedia: ' + error);
      }
    );
  });
}


  uploadFileHttp(file: any, formData: FormData, url: any): Observable<HttpEvent<any>>{
    return this.httpc.post(url , formData, {responseType: 'text', reportProgress: true, observe: 'events'
    });
  }

  pickmultimedia(){
    return new Promise((resolve, reject) =>{
      this.fileChooser.open().then((fileuri)=>{
        this.filePath.resolveNativePath(fileuri).then((resolvenativePath)=>{
          this.image= Capacitor.convertFileSrc(resolvenativePath);
          if (isVideo(this.image)==false && isImage(this.image)==false){
            Swal2.fire({
              title: 'Error de archivo',
              text: 'El formato del archivo no es valido solo videos o imagenes',
              icon: 'warning',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
          }else{
            this.readBlobFile(resolvenativePath)
              .then((response)=>{
               resolve(true);
            });
          }
        });
      });
    });
  }

  // Update the readBlobFile method in UploadMultimediaService class
  public readBlobFile(src: string): Promise<void> {
    console.log("Source file:", src);
    return new Promise((resolve, reject) => {
      this.file
        .resolveLocalFilesystemUrl(src)
        .then((entry) => {
          if (entry.isFile) {
            return this.readFile(entry.nativeURL);
          } else {
            throw new Error("The provided source is not a file.");
          }
        })
        .then((arrayBuffer) => {
          const ext = src.substr(src.lastIndexOf('.') + 1);
          const filename = uuid.v4() + '.' + ext;
          const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
          this.blob = blob;
          this.filename = filename;
          console.log("Blob and filename after reading file:", this.blob, this.filename);
          resolve();
        })
        .catch((error) => {
          console.log("Error reading blob file:", error);
          reject(error);
        });
    });
  }
  
  private readFile(path: string): Promise<ArrayBuffer> {
    console.log("Reading file:", path);
    return new Promise((resolve, reject) => {
      window['resolveLocalFileSystemURL'](path,
        (fileEntry) => {
          fileEntry.file(
            (file) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                resolve(reader.result as ArrayBuffer);
              };
              reader.onerror = (error) => {
                console.log("Error reading file:", error);
                reject(error);
              };
              reader.readAsArrayBuffer(file);
            },
            (error) => {
              console.log("Error getting file:", error);
              reject(error);
            }
          );
        },
        (error) => {
          console.log("Error resolving local file system URL:", error);
          reject(error);
        }
      );
    });
  }
  
  
  

  


  public uploadFile(blobfile, filename?): Promise<UploadResponse> {
    console.log("Filename before calling uploadtoS3:", filename);
    console.log('File object before calling uploadToS3:', blobfile);
    return new Promise((resolve, reject) => {
      if (!blobfile) {
        reject(new Error('Invalid multimedia file: missing file.'));
        return;
      }
      const extension = (filename || '').toLowerCase().split('.').pop();
      const inferredMimeByExtension: { [key: string]: string } = {
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        webp: 'image/webp',
        gif: 'image/gif',
        mp4: 'video/mp4',
        mov: 'video/quicktime',
        m4v: 'video/x-m4v',
        webm: 'video/webm'
      };
      const resolvedMimeType = blobfile.type || inferredMimeByExtension[extension] || '';
      if (!resolvedMimeType) {
        reject(new Error('Invalid multimedia file: missing mime type.'));
        return;
      }
      this.setUploadUiState({
        active: true,
        phase: 'preparing',
        percent: 0,
        loaded: 0,
        total: 0,
        title: 'Alien Superintelligence Upload',
        message: 'Encoding your media. Please stay in the app while the uplink stabilizes.',
      });
      //primera notificacion para indicar el usuario que no cierre
      if (this.platform.is('android') || this.platform.is('ios')) {
        this.localNotification.schedule({
          title: 'Subiendo multimedia al servidor',
          text: 'Do not close the app until this notification disappears',
          foreground: true,
        });
      }
      const idNotification = 0;
      console.log('About to call this.getS3Form() with file.type:', resolvedMimeType);
      this.getS3Form(resolvedMimeType, filename).then((result) => {
        const params = result;
        const fields = params['s3_form'];
        const formdata = new FormData();
        const url = params['s3_form']['url'];
        if(filename != null){
          this.filename = filename;
        }
        console.log('About to call this.uploadToS3() with file:', blobfile, 'filename:', filename, 'formdata:', formdata, 'url:', url, 'fields:', fields);
        this.uploadToS3(blobfile, filename,formdata,url, fields)
        .then(({ link, mimeType }) => {
            if (this.platform.is('android') || this.platform.is('ios')) {
              this.localNotification.cancelAll();
            }
            this.cameraService.presentToastWithOptions();
            this.image = '';
            resolve({ link: link, mimeType: resolvedMimeType });
          }).catch((errorS3Upload) => {
            this.resetUploadUiState(1800);
            reject(errorS3Upload);
          });
      }).catch((errorS3Form) => {
        this.setUploadUiState({
          active: true,
          phase: 'error',
          title: 'Upload Interrupted',
          message: 'The media uplink could not be prepared. Please try again.',
        });
        this.resetUploadUiState(1800);
        reject(errorS3Form);
      });
    });
  }
  


  //async uploadToS3(file: any, filename: string, url: string): Promise<any> {
    
    //if (!file) {
      //console.error('File object is undefined');
 //     return Promise.reject('File object is undefined');
 //   }
  
   // console.log('Uploading file:', file, 'with filename:', filename, 'to URL:', url);
   // const headers = new HttpHeaders().set('Content-Type', file.type);
//    const req = new HttpRequest('PUT', url, file, {
  //    reportProgress: true,
 //     headers: headers,
   // });
//    console.log('File type:', file.type);
 //   console.log('File name:', filename);
 //   console.log('Headers:', headers);
    
  //  return new Promise((resolve, reject) => {
  //    this.httpc.request(req).subscribe(
  //      (event: HttpEvent<any>) => {
   //       if (event.type === HttpEventType.UploadProgress) {
   //         console.log(`Progress: ${(event.loaded * 100) / event.total}%`);
   //       } else if (event.type === HttpEventType.Response) {
  //          const uploadedUrl = `${url.split('?')[0]}`;
  //          console.log('File uploaded successfully:', uploadedUrl);
   //         resolve(uploadedUrl);
 //         }
 //       },
 //       (error) => {
  //        console.error('Error uploading file:', error);
 //         reject('Error uploading file: ' + error);
 //       }
 //     );
 //   });
  //}
  
  
  post(blobfile?, filename?): Promise<UploadResponse> {
    return new Promise((resolve, reject) => {
      try {
        const existingMedia = this.resolveExistingPublicationMedia(blobfile);
        if (existingMedia) {
          resolve({
            link: existingMedia.remoteUrl,
            mimeType: existingMedia.mimeType,
          });
          return;
        }
      } catch (error) {
        reject(error);
        return;
      }

      //if (blobfile != null) {
        //this.blob = blobfile;
      //}else {
        //blobfile = this.blob;
        //filename = this.filename;
      //}
      console.log("Uploading blob:", blobfile);
      this.uploadFile(blobfile, filename)
        .then(async (response: UploadResponse) => {
          // Upload a real frame rather than asking a social crawler to decode
          // the movie. Poster generation is best-effort and must never block a
          // publication when a device cannot decode a particular codec.
          let poster: UploadResponse | null = null;
          if (String(response.mimeType || '').toLowerCase().startsWith('video/')) {
            try {
              poster = await this.uploadVideoPoster(blobfile, filename);
            } catch (posterError) {
              // The original video is already in S3. A browser that cannot
              // decode its codec must never turn a successful video upload
              // into a failed publication.
              console.warn('[UploadMultimedia] Video poster generation skipped:', posterError);
            }
          }
          console.log('Uploaded successfully. Link:', response.link, 'Type:', response.mimeType);
          resolve({
            ...response,
            ...(poster?.link ? { posterLink: poster.link } : {}),
          });
        }).catch((error) => {
          console.error('Error in post method:', error);
          reject(error);
        });
    });
  }

  /**
   * Creates a small, crawler-friendly poster for a video in the browser.
   * Social crawlers (WhatsApp/X/etc.) generally do not decode the video URL,
   * so every newly published video gets a stable image URL as well.
   */
  public async createVideoPoster(video: Blob): Promise<Blob | null> {
    if (!video || !String(video.type || '').toLowerCase().startsWith('video/')) {
      return null;
    }

    const videoElement: any = document.createElement('video');
    const objectUrl = URL.createObjectURL(video);
    videoElement.preload = 'metadata';
    videoElement.muted = true;
    videoElement.playsInline = true;
    videoElement.src = objectUrl;

    const waitFor = (eventName: string, timeoutMs: number = 10000): Promise<void> =>
      new Promise((resolve, reject) => {
        let settled = false;
        const finish = (error?: any) => {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          videoElement.removeEventListener(eventName, onEvent);
          videoElement.removeEventListener('error', onError);
          error ? reject(error) : resolve();
        };
        const onEvent = () => finish();
        const onError = () => finish(new Error('Unable to decode video poster frame.'));
        const timeout = setTimeout(() => finish(new Error('Video poster timed out.')), timeoutMs);
        videoElement.addEventListener(eventName, onEvent, { once: true });
        videoElement.addEventListener('error', onError, { once: true });
      });

    try {
      await waitFor('loadedmetadata');
      const duration = Number.isFinite(videoElement.duration) ? videoElement.duration : 0;
      // The beginning of a video is commonly a fade-in or a blank first frame.
      // Seek to its middle, retaining a small tail margin for media where the
      // final frame cannot be decoded reliably by the browser.
      const targetTime = duration > 0
        ? Math.max(0.1, Math.min(duration * 0.5, Math.max(0.1, duration - 0.1)))
        : 0;
      if (targetTime > 0) {
        videoElement.currentTime = targetTime;
        await waitFor('seeked');
      } else {
        await waitFor('loadeddata');
      }

      const width = Math.max(1, Number(videoElement.videoWidth) || 1);
      const height = Math.max(1, Number(videoElement.videoHeight) || 1);
      const maxWidth = 1280;
      const scale = Math.min(1, maxWidth / width);
      const canvas: HTMLCanvasElement = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      const context = canvas.getContext('2d');
      if (!context) return null;
      context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

      return await new Promise<Blob | null>((resolve) =>
        canvas.toBlob(resolve, 'image/jpeg', 0.86)
      );
    } catch (error) {
      console.warn('[UploadMultimedia] Could not create video poster:', error);
      return null;
    } finally {
      URL.revokeObjectURL(objectUrl);
      videoElement.removeAttribute('src');
      try { videoElement.load(); } catch { /* noop */ }
    }
  }

  /** Uploads a generated poster and returns its public URL. Failure is
   * intentionally non-fatal: the publication itself can still be created. */
  public async uploadVideoPoster(video: Blob, filename: string = 'video'): Promise<UploadResponse | null> {
    const poster = await this.createVideoPoster(video);
    if (!poster) return null;
    const baseName = String(filename || 'video').replace(/\.[^/.]+$/, '') || 'video';
    try {
      return await this.uploadFile(poster, `${baseName}-poster.jpg`);
    } catch (error) {
      console.warn('[UploadMultimedia] Video poster upload failed:', error);
      return null;
    }
  }
  


    

}
